// extracted by mini-css-extract-plugin
export default {"inputBox":"input_inputBox__6MFJW","label":"input_label__2mDSS","icon":"input_icon__rlYf6","input":"input_input__Rz6ZX","container":"input_container__j2a1R"};